import './home.scss';

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Row, Col, Alert, Button } from 'reactstrap';

import { useAppSelector } from 'app/config/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Home = () => {
  const account = useAppSelector(state => state.authentication.account);

  if (!(account && account.login)) {
    window.location.replace('/login');
  }

  return (
    <Row>
      <Col md="3" className="pad"></Col>
      <Col md="9">
        <h2>Welcome to Ensolvers QA Challenge!</h2>
        {account && account.login ? (
          <div>
            <Alert color="success">You are logged in as &quot;{account.login}&quot;.</Alert>
            <Row>
              <Col md="6">
                <Button
                  className="mr-2"
                  color="info"
                  onClick={() => {
                    window.location.replace('/to-do-item');
                  }}
                >
                  <FontAwesomeIcon icon="list" />
                  &nbsp; Manage To-Do Items
                </Button>
              </Col>
              <Col md="6">
                <Button
                  className="mr-2"
                  color="info"
                  onClick={() => {
                    window.location.replace('/folder');
                  }}
                >
                  <FontAwesomeIcon icon="list" />
                  &nbsp; Manage Folders
                </Button>
              </Col>
            </Row>
          </div>
        ) : (
          <div>
            <Alert color="warning">
              You are not logged please sign-in clicking
              <span>&nbsp;</span>
              <Link to="/login" className="alert-link">
                HERE
              </Link>
            </Alert>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default Home;
